<template>
  <div id="modalSpecifics" class="modal fade">
    <div class="modal-dialog modal-dialog-vertical-center modal-lg" role="document">
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("outside.更多扩展属性")}}</h6>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <ul>
            <li v-for="item in items" :key="item.name + item.value" class="row mg-b-10">
              <span class="mg-r-10">{{item.vName}}：</span>
              <span class=" tx-gray-700">{{item.value}}</span>
            </li>
          </ul>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-secondary tx-14 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal" >{{$t("outside.关闭")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items"],
};
</script>

<style lang="less" scoped>
ul{
  margin: 0;
  padding: 0 15px;
  li{
    padding: 0 5px;
    line-height: 22px;
    font-size: 12px;
  }
  li:nth-child(odd){
    background-color: #f6f6f6;
  }
}
</style>
